
import { defineComponent, reactive } from 'vue'
import { store } from '@/store'

import router from '@/router'
import { RouteSettingsModel, RouteSettingsPreset } from '@/api/tripply/models'

export default defineComponent({
  name: 'CreateRoute',
  setup() {
    const state = reactive<{
      step: number;
      name: string;
      preset: string;
    }>({
      step: 1,
      name: '',
      preset: ''
    })
    
    let routeSettings = new RouteSettingsModel()

    function setRoutePreset(preset: RouteSettingsPreset) {     
      routeSettings = new RouteSettingsModel(preset)
      state.name = routeSettings.name
      state.step = 2
    }

    function create() {
      routeSettings.name = state.name
      const routeId = store.route.createRoute(routeSettings)
      store.modal.hideModal('CreateRoute')
      routeId && router.push(`/r/${routeId}`)
    }
    return { create, state, setRoutePreset }
  }
})
